import React from 'react';
import PropTypes from 'prop-types';
import loadScript from 'lib/loadScript';
import { content as ContentPropType } from 'lib/CustomPropTypes';
import { isValidUrl } from 'lib/urlUtils';
import Link from 'components/Link';

const ConditionalLink = ({ to, children }) => {
  if (typeof to !== 'undefined' && isValidUrl(to)) {
    return (
      <Link to={to}>
        {children}
        <span className="icon icon-arrow-link" />
      </Link>
    );
  }
  return children;
};

function FeaturedEmbed(props) {
  const {
    block,
    content: {
      computedValues: {
        url: embedUrl,
      } = {},
      id,
      metadata: {
        embedHeadline,
        embedHeadlineUrl,
        label,
        title: packageTitle,
      } = {},
    },
  } = props;

  const embedID = `embed-${id}`;

  React.useEffect(() => {
    if (embedUrl) {
      loadScript('https://nodeassets.nbcnews.com/cdnassets/pym/1.3.2/pym.min.js')
        .then(() => {
          if (window.pym) {
            // Strip query string params from url that might have been copied from development.
            const cleanedEmbedUrl = embedUrl.replace(/&(childId|parentUrl)=[^&]+/g, '');
            // Pym adds iframe and establishes communication for controlling height.
            window[embedID] = new window.pym.Parent(embedID, cleanedEmbedUrl);
          }
        });
    }
  }, []);

  const hasTitle = packageTitle && packageTitle.length > 0;
  const hasHeadline = embedHeadline && embedHeadline.length > 0;
  const hasLabel = label && label.length > 0;

  return (
    <div className={`${block}__embed ${hasTitle ? `${block}__embed--package-title` : ''}`} data-contentid={id}>
      <div className={`${block}__embed-element`}>
        <div id={embedID} />
      </div>
      {(hasHeadline || hasLabel) && (
        <h2 className={`${block}__headline`}>
          <ConditionalLink to={embedHeadlineUrl}>
            {/* TODO: BENTO-15783 extract this flag to sub component */}
            {(label) && (
              <span className={`${block}__flag`}>
                {label}
                {hasHeadline && (
                  <>
                    &nbsp;
                    {'/ '}
                  </>
                )}
              </span>
            )}
            {hasHeadline && (
              <span className={`${block}__headline-text`}>
                {embedHeadline}
              </span>
            )}
          </ConditionalLink>
        </h2>
      )}
    </div>
  );
}

FeaturedEmbed.propTypes = {
  block: PropTypes.string,
  content: ContentPropType.isRequired,
};

FeaturedEmbed.defaultProps = {
  block: null,
};

export { FeaturedEmbed };
